module.exports = __webpack_public_path__ + "static/media/logo_inar.e6652907.png";


//////////////////
// WEBPACK FOOTER
// ./src/inar2/images/logo_inar.png
// module id = 709
// module chunks = 0